import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError, finalize, Observable, of, shareReplay } from 'rxjs';

import { WINDOW_NAVIGATOR } from './window-navigator.token';
import { UserResponse } from './user-response';
import { CsrfService } from './csrf.service';
import { backendUrl } from './backend-url';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private readonly http = inject(HttpClient);
  private readonly navigate = inject(WINDOW_NAVIGATOR);
  private readonly csrf = inject(CsrfService);

  readonly currentUser$: Observable<UserResponse | null> = this.http
    .get<UserResponse>(backendUrl('/user/current'))
    .pipe(
      catchError((error: unknown) => {
        if (error instanceof HttpErrorResponse && (error.status === 401 || error.status === 403)) {
          this.csrf.clear();
          return of(null);
        }
        throw error;
      }),
      shareReplay({ bufferSize: 1, refCount: true })
    );

  login(): void {
    this.navigate(backendUrl('/oauth2/authorization/keycloak'));
  }

  logout$(): Observable<void> {
    return this.http
      .post<void>(backendUrl('/logout'), null)
      .pipe(finalize(() => this.csrf.clear()));
  }
}
